import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- WEEKS ---------------------------------------*
  // *===============================================---*
  {
    path: '/week/list',
    name: 'pages-weeks-list',
    component: () => import('@/views/pages/week/WeeksList.vue'),
    meta: {
      resource: 'week',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('weeks.mainVerticalMenu.weeks'),
    },
  },
  {
    path: '/week/add',
    name: 'pages-weeks-add',
    component: () => import('@/views/pages/week/WeekAdd.vue'),
    meta: {
      resource: 'week',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('weeks.mainVerticalMenu.weeks'),
    },
  },
  {
    path: '/week/edit/:id',
    name: 'pages-weeks-edit',
    component: () => import('@/views/pages/week/WeekEdit.vue'),
    meta: {
      resource: 'week',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('weeks.mainVerticalMenu.weeks'),
    },
  },
]
